export const loadCreateCoreUIV8ThemeFromV9 = () =>
  import(
    /* webpackChunkName: "4-feat-coreui-v8-theme-from-v9" */
    './createCoreUIV8ThemeFromV9'
  );
